export const ETH_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;

export const INVALID_CLIPBOARD_CONTENT = "Clipboard content is not a valid ETH address";

